// status
export const TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  PASSWORD: 'password',
};

export default { TYPE };
